import { FieldSet, Heading, Image, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';
import { EXTERNAL_WIZARD_OPTIONS } from '../../../constants/stringConstants';
import Trophy from '../../../../../images/trophy.svg';

export default function CongratulationsIsYourNewLeaseReady({ onRadioSelect }: { onRadioSelect }) {
  return (
    <>
      <Image src={Trophy} alt="trophy" css={{ height: '160px', width: '160px', marginBottom: 'loose' }} />
      <Heading
        level={2}
        css={{
          textStyle:
            'responsive.heading-md' /* oxlint-disable-line constellation/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
          marginBottom: 'tight',
        }}
      >
        Congratulations
      </Heading>
      <FieldSet required legend={<Legend>Would you like to create a new lease now?</Legend>}>
        <LabeledControl
          label={<Label>Yes</Label>}
          control={
            <Radio
              name="congratulations-is-your-new-lease-ready"
              onChange={onRadioSelect}
              value={EXTERNAL_WIZARD_OPTIONS.CREATE_LEASE}
            />
          }
        />
        <LabeledControl
          label={<Label>No</Label>}
          control={
            <Radio
              name="congratulations-is-your-new-lease-ready"
              onChange={onRadioSelect}
              value={EXTERNAL_WIZARD_OPTIONS.SEND_TO_PROPERTY_DASHBOARD}
            />
          }
        />
      </FieldSet>
    </>
  );
}
